export function chatContextIdentity(
  contextPath?: string,
  reportProviderId?: string,
  subjectUserId?: string,
): string {
  return [
    contextPath?.trim() ?? "",
    reportProviderId?.trim() ?? "",
    subjectUserId?.trim() ?? "",
  ].join("\u001f");
}
